import type { Announcement } from '../types';

export const a_2026_07_20: Announcement = {
  id: '2026-07-20-numerotation-ia',
  date: '2026-07-20',
  layout: 'spotlight',
  kicker: 'Mise à jour produit · 20 juillet 2026',
  title: "Hector s'améliore : la numérotation de vos pièces, confiée à l'IA",
  navLabel: "Numéroter avec l'IA",
  subtitle: '',
  intro: [
    "Dans « Tamponner mes pièces » comme dans « Numéroter mes pièces », vous pouvez désormais confier la numérotation à Hector. Dites-lui sur quoi vous appuyer : un acte que vous déposez, une écriture déjà présente dans le dossier ou vos consignes directement. Il numérote les pièces pour vous.",
    "Hector vous présente la numérotation qu'il propose avant de l'appliquer : vous la validez, l'ajustez ou la complétez, et vous pouvez à tout moment reprendre la main sur la numérotation manuelle.",
  ],
  videoCaption: 'Découvrez-le en vidéo',
  // Embed YouTube — https://youtu.be/1zBPlgjvrlM
  // Même vidéo que la fiche `numeroter-pieces-ia` du centre d'aide
  // (helpArticles.ts) : une seule captation, deux surfaces de lecture.
  video: { provider: 'youtube', id: '1zBPlgjvrlM' },
  sections: [
    {
      label: "Sur quoi Hector s'appuie",
      features: [
        {
          id: 'source-acte-depose',
          title: 'Un acte que vous déposez',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "Déposez vos conclusions ou votre assignation : Hector y relève les pièces citées et reprend leur numérotation pour l'appliquer à votre dossier.",
            ],
          },
        },
        {
          id: 'source-ecriture-dossier',
          title: 'Une écriture déjà dans le dossier',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "Rien à déposer : désignez une écriture déjà présente dans le dossier, Hector la lit directement et s'en sert de référence.",
            ],
          },
        },
        {
          id: 'source-consignes',
          title: 'Vos consignes, tout simplement',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "Sans document de référence, expliquez-lui ce que vous attendez : l'ordre à suivre, les pièces à écarter et la numérotation à repartir. Échangez avec lui jusqu'au résultat voulu.",
            ],
          },
        },
      ],
    },
    {
      label: 'Où la retrouver',
      features: [
        {
          id: 'deux-entrees',
          title: 'Deux entrées, un même parcours',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "Depuis « Tamponner mes pièces », à l'étape de numérotation, ou depuis « Numéroter mes pièces » dans vos pièces du dossier : le bouton « Numéroter avec l'IA » ouvre le même parcours.",
              "Une fois les pièces numérotées, Hector vous propose d'enchaîner : revenir à la numérotation pour la vérifier ou passer directement au tamponnage.",
            ],
          },
        },
      ],
    },
  ],
  footer: {
    text: "La vidéo est aussi disponible dans le centre d'aide.",
    cta: {
      label: "Ouvrir le centre d'aide",
      url: 'https://www.app.hector.legal/aide/numeroter-pieces-ia',
    },
  },
};
